<div class="dialogo">
    <h1 mat-dialog-title class="titulo">Actualizar Menú desde archivo</h1>
    <div mat-dialog-content>
        <p class="nombreMenu">Menu: {{data.descripcion}}</p>

        <div  style="padding-bottom: 5px; padding-top: 5px;" *ngIf="!finalizado">
            <button color="primary" type="button" mat-raised-button (click)="fileInput.click()" [disabled]="ejecutando"
                style="background-color: #108f5a;padding-bottom: 5px; padding-top: 5px">Seleccionar archivo
                <mat-icon >upload_file</mat-icon>
            </button>
            <input hidden (change)="onFileSelected($event)" #fileInput type="file" accept="application/JSON">
            
        </div>
        <div  style="padding-bottom: 5px; padding-top: 5px;" *ngIf="!ejecutando">
            <span class="file-name">{{selectedFile?.name}}</span>
        </div>
        <div  style="padding-bottom: 5px; padding-top: 5px;" *ngIf="ejecutando">
            <span class="file-name-ejecutando">{{selectedFile?.name}}</span>
        </div>
        <div  style="padding-bottom: 5px; padding-top: 5px;" *ngIf="mostrarMensajeEjecutando">
            <span class="waiting">Procesando importación. Por favor espere un momento</span>
        </div>
        <div  class="mensajeExitoso" *ngIf="finalizado">
            <div>
                <span ><mat-icon mat-list-icon class="waiting"  *ngIf="destinatarios.length ==0 && destinatariosNoAsociados.length ==0 && validaciones.length ==0">warning</mat-icon>El contenido del menú se actualizó correctamente.</span>
            </div>
            <div *ngIf="destinatarios.length > 0">
                <br>
                <span *ngIf="destinatarios.length ==1"><b>El destinatario siguiente no existe en la configuración.</b></span>
                <span *ngIf="destinatarios.length > 1"><b>Los destinatarios siguientes no existen en la configuración.</b></span>
                <mat-list>
                    <mat-list-item *ngFor="let destinatario of destinatarios">
                        <mat-icon mat-list-icon class="waiting" >warning</mat-icon>
                        <h4 mat-line>{{destinatario}}</h4>
                    </mat-list-item>
                </mat-list>
            </div>
            <div *ngIf="destinatariosNoAsociados.length > 0">
                <br>
                <span *ngIf="destinatariosNoAsociados.length ==1" ><b>El destinatario siguiente no está asociado al menú.</b></span>
                <span *ngIf="destinatariosNoAsociados.length > 1"><b>Los destinatarios siguientes no están asociados al menú.</b></span>
                <mat-list>
                    <mat-list-item *ngFor="let destinatario of destinatariosNoAsociados">
                        <mat-icon mat-list-icon class="waiting" >warning</mat-icon>
                        <h4 mat-line>{{destinatario}}</h4>
                    </mat-list-item>
                </mat-list>
            </div>
            <div *ngIf="validaciones.length > 0">
                    <br>
                    <span *ngIf="validaciones.length ==1"><b>La validación siguiente no existe en la configuración.</b></span>
                    <span *ngIf="validaciones.length > 1"><b>Las validaciones siguientes no existen en la configuración.</b></span>
                    <mat-list>
                        <mat-list-item *ngFor="let validacion of validaciones">
                            <mat-icon mat-list-icon class="waiting" >warning</mat-icon>
                            <h4 mat-line>{{validacion}}</h4>
                        </mat-list-item>
                    </mat-list>
                </div>
            <div *ngIf="destinatarios.length > 0 || destinatariosNoAsociados.length > 0 || validaciones.length > 0">
                <br>
                <span>Por favor verifique el contenido del árbol.</span>
                <span>También puede descargar los destinatarios/validaciones faltantes aquí.</span>
                <span class="padding-right-10" >
                    <button mat-raised-button color="primary" (click)="exportarDestinatariosValidacionesFaltantes()" 
                        [ngStyle]="habilitarBotonImportar?{'background-color': '#3f51b5'} : {'background-color': 'rgba(0,0,0,.12)','color':'#3a3737','font-size':'14px'}"
                        style="padding-bottom: 5px; padding-top: 5px;margin-right: 10px;">
                        Descargar faltantes
                        <mat-icon >file_download</mat-icon>
                    </button>
                </span>
            </div>
           
        </div>
        <div  style="padding-bottom: 5px; padding-top: 5px;" *ngIf="error">
            <span class="error">{{mensaje}}</span>
         </div>
    </div>
    <div mat-dialog-actions>
            <span class="padding-right-10" *ngIf="!finalizado">
                <button mat-raised-button color="primary" (click)="importarMenu()" [disabled]="!habilitarBotonImportar"
                    [ngStyle]="habilitarBotonImportar?{'background-color': '#3f51b5'} : {'background-color': 'rgba(0,0,0,.12)','color':'#3a3737','font-size':'14px'}"
                    style="padding-bottom: 5px; padding-top: 5px;margin-right: 10px;">
                    Importar Menú
                    <mat-icon >file_upload</mat-icon>
                </button>
            </span>
            <span class="padding-right-10" *ngIf="!finalizado">
                <button mat-raised-button  style="padding-bottom: 5px; padding-top: 5px;" (click)="cancelarAceptar()">
                    Cancelar
                    <mat-icon >cancel</mat-icon>
                </button>
            </span>
            <span class="padding-right-10" *ngIf="finalizado">
                <button mat-raised-button color="primary" style="padding-bottom: 5px; padding-top: 5px;" (click)="cancelarAceptar()">
                    Aceptar
                </button>
            </span>
    </div>
</div>

